// extracted by mini-css-extract-plugin
export default {"settingsSection":"SettingsSection_settingsSection__n8KXc"};